import types from '../mutation-types';
import interactionHistoryAPI from '../../api/interaction_histories';

export const state = {
  records: [],
  meta: {
    count: 0,
    current_page: 1,
    pageSize: 25,
    reports: {
      success: 0,
      failure: 0,
      unknown: 0,
      total_cost: 0,
      total_duration: 0,
    },
    sorts: [],
  },
  uiFlags: {
    isFetching: false,
  },
};

const getters = {
  getInteractionHistoriesUIFlags(_state) {
    return _state.uiFlags;
  },
  getInteractionHistoriesMeta(_state) {
    return _state.meta;
  },
  getInteractionHistories(_state) {
    return _state.records;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getMeta(_state) {
    return _state.meta;
  },
  getRecords(_state) {
    return _state.records;
  },
};

const actions = {
  fetchInteractionHistories: async ({ commit, state: currentState }, query) => {
    commit(types.SET_INTERACTION_HISTORIES_UI_FLAG, { isFetching: true });
    try {
      // empty the previous data
      commit(types.SET_INTERACTION_HISTORIES_LIST, []);

      const queryParams = { ...query };
      if (!queryParams.group) {
        delete queryParams.group;
      }
      const response = await interactionHistoryAPI.fetchAgentInteactionHistory(
        queryParams
      );
      const newData = response.data?.data || [];
      const meta = response.data?.meta || currentState.meta;

      if (query.page === 1) {
        commit(types.SET_INTERACTION_HISTORIES_LIST, newData);
      } else {
        const combined = [...currentState.records, ...newData];
        commit(types.SET_INTERACTION_HISTORIES_LIST, combined);
      }
      commit(types.SET_INTERACTION_HISTORIES_META, meta);
      commit(types.SET_INTERACTION_HISTORIES_UI_FLAG, { isFetching: false });
    } catch (error) {
      console.error('Error fetching interaction histories:', error);
      commit(types.SET_INTERACTION_HISTORIES_UI_FLAG, { isFetching: false });
      throw error;
    }
  },
  fetchInteractionHistoriesFiltered: async (
    { commit, state: currentState },
    query
  ) => {
    commit(types.SET_INTERACTION_HISTORIES_UI_FLAG, { isFetching: true });
    try {
      // empty the previous data
      commit(types.SET_INTERACTION_HISTORIES_LIST, []);

      const queryParams = { ...query };
      if (!queryParams.group) {
        delete queryParams.group;
      }
      const response = await interactionHistoryAPI.getAgentInteractionHistoryFilterList(
        queryParams
      );
      const newData = response.data?.data || [];
      const meta = response.data?.meta || currentState.meta;

      if (query.page === 1) {
        commit(types.SET_INTERACTION_HISTORIES_LIST, newData);
      } else {
        const combined = [...currentState.records, ...newData];
        commit(types.SET_INTERACTION_HISTORIES_LIST, combined);
      }
      commit(types.SET_INTERACTION_HISTORIES_META, meta);
      commit(types.SET_INTERACTION_HISTORIES_UI_FLAG, { isFetching: false });
    } catch (error) {
      console.error('Error fetching filtered interaction histories:', error);
      commit(types.SET_INTERACTION_HISTORIES_UI_FLAG, { isFetching: false });
      throw error;
    }
  },
};

const mutations = {
  [types.SET_INTERACTION_HISTORIES_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },
  [types.SET_INTERACTION_HISTORIES_META]($state, meta) {
    $state.meta = {
      ...meta,
      count: meta.count || 0,
      current_page: meta.current_page || 1,
      pageSize: meta.pageSize || 25,
      reports: meta.reports || $state.meta.reports,
      sorts: meta.sorts || [],
    };
  },
  [types.SET_INTERACTION_HISTORIES_LIST]($state, data) {
    $state.records = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
